var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 358.97,
    height: 359.02,
    viewBox: "0 0 358.97 359.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d93833;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "erroe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359,179.55A179.49,179.49,0,1,1,179.65,0,179.2,179.2,0,0,1,359,179.55ZM210.49,84v-2.1a31,31,0,0,0-52.8-22c-7.73,7.68-9.88,17.1-9,27.69,1.79,22.55,3.33,45.12,4.95,67.69,1.65,22.9,3.21,45.8,4.93,68.7a21,21,0,0,0,41.89.28c1.47-19,2.74-38,4.09-57q1.32-18.54,2.65-37.09C208.28,114.57,209.41,99,210.49,84ZM178.37,310.58c13.08.95,25.07-9.56,26.11-22.9,1.08-13.78-9.2-26.11-22.62-27.12-14.14-1.07-26.29,9.09-27.36,22.89C153.39,297.8,163.7,309.52,178.37,310.58Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.6588bfc4e0bb2730684343b8fba70723.svg";
export { ForwardRef as ReactComponent };